import { HeadLine } from '../../../layouts/headers/HeadLine'
import SimpleAccordion from '../components/SimpleAccordion';

export const Regulation = () => {

    const rules = [
        {
            icon: 'register-icon.svg',
            title: 'Registro',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        },
        {
            icon: 'exit-icon.svg',
            title: 'Salida',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        },
        {
            icon: 'persons-icon.svg',
            title: 'Invitados',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        },
        {
            icon: 'register-icon.svg',
            title: 'Condiciones de Admisión',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        },
        {
            icon: 'verified-persons-icon.svg',
            title: 'Uso de Instalaciones',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        }
    ];

    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Reglamento del hotel' backurl='/hotel-info' />
            </div>

            <div className='w-full relative content-hi-sm'>
                <SimpleAccordion items={rules} />
            </div>
        </>
    )
}
